import { getIn } from 'formik';
import _ from 'lodash';
import React from 'react';

import { WipConfig } from '../../types';
import { DeleteIconButton } from 'packages/common-frontend/components/IconButton';

/**
 * This component should be used to delete entities that are contained in an array
 */
export const DeleteArrayPropertyButton: React.FC<{
  wipConfig: WipConfig;
  basePropertyKey: string;
  idx: number;
}> = ({
  wipConfig: { formProps, capitalProvidersMap, setCapitalProvidersMap },
  basePropertyKey,
  idx,
}) => {
  return (
    <DeleteIconButton
      ariaLabel="delete"
      label="Delete"
      onClick={(event) => {
        if (event) {
          event.stopPropagation();
        }
        const propertySection = _.cloneDeep(
          getIn(formProps.values, basePropertyKey),
        );
        const [removedItem] = propertySection.splice(idx, 1);
        if (
          basePropertyKey === 'facilityMechanics.parties.capitalProviders' &&
          removedItem
        ) {
          const omittedCapitalProviderMap = _.omit(
            capitalProvidersMap,
            removedItem.entity.id,
          );
          setCapitalProvidersMap(omittedCapitalProviderMap);
        }
        return formProps.setFieldValue(basePropertyKey, propertySection);
      }}
    />
  );
};
